import { QodoAnteater, QodoText } from 'logos';

export const LoginLogo = () => (
  <header className="flex items-center gap-1">
    <QodoAnteater size="46px" />
    <QodoText className="w-[70px] h-10" />
  </header>
);
